import React from "react";
import "./Labpanelitemcdmqb.css";

export default function LabPanelItemCDMQB(props) {
  return (
    <div className="labPanelItemContainerCDMQB">
      <p className="labPanelItemTitleCDMQB">{props.title}</p>
      {props.contents.map((value, index) => (
        <p className="labPanelItemTextCDMQB" key={`itemText${index}`}>
          {value}
        </p>
      ))}
      {props.indentedContents &&
        props.indentedContents.map((value, index) => (
          <p
            className="labPanelItemTextCDMQB labPanelIndentedItemTextCDMQB"
            key={`indentedItemText${index}`}
          >
            {value}
          </p>
        ))}
    </div>
  );
}
